import { boolean, pgTable, unique } from 'drizzle-orm/pg-core';
import { orgPrimaryKey, orgTableBase } from './org-id';
import { relations } from 'drizzle-orm';
import { Org } from './org';
import { AmsClassicOrgConfig, Profile, Team } from '../schema';
import { settingsColumns } from '../settings-columns';
import { DEFAULT_PROFILE_ROLE, ProfileRoleType } from '../enums';
export const Org_Relations = relations(Org, ({ many, one }) => ({
    settings: one(OrgSettings),
    axleTeams: many(Team),
    axleProfiles: many(Profile),
    teams: many(Team),
    amsClassicConfig: one(AmsClassicOrgConfig),
}));
export const OrgSettings = pgTable('org_settings', {
    ...orgTableBase,
    ...settingsColumns,
    enableTeamLibrary: boolean('enable_team_library').notNull().default(false),
    requireExerciseMetadataFields: boolean('require_exercise_metadata_fields').notNull().default(false),
    showBaseLibrary: boolean('show_base_library').notNull().default(false),
    defaultCoachRole: ProfileRoleType('default_coach_role')
        .notNull()
        .default(DEFAULT_PROFILE_ROLE),
    /**
     * How to read a Hub membership that carries the Athlete user type *and*
     * another user type.
     *
     * Off (default, and how every org behaved before this setting existed):
     * the extra user type makes the profile a coach on that team as well as an
     * athlete. Coaches who program for a team and want to review that
     * programming in the mobile app rely on this.
     *
     * On: the Athlete user type wins and the profile is treated as an athlete
     * only. For orgs that use a second user type as a roster tag (e.g.
     * "Futures") rather than a coaching assignment.
     */
    athleteUserTypeTakesPrecedence: boolean('athlete_user_type_takes_precedence')
        .notNull()
        .default(false),
}, (table) => ({
    pk: orgPrimaryKey(table),
    orgUq: unique().on(table.orgId),
}));
export const OrgSettings_Relations = relations(OrgSettings, ({ one }) => ({
    org: one(Org, {
        fields: [OrgSettings.orgId],
        references: [Org.id],
    }),
}));
//# sourceMappingURL=org-misc.js.map